import { type UserState } from './types';

export const initialUserState: UserState = {
  user: {
    username: '',
    email: '',
    name: '',
    picture: '',
    roles: [],
    id: '',
  },
  menu: {
    isLoading: true,
    elements: [],
  },
  impersonatedUser: {
    user: undefined,
    isLoading: false,
  },
};
